import EventBus from "@plugins/common/service/eventbus";

const dynamicLinkEventBus = new EventBus();
export default dynamicLinkEventBus;
